import { FAST_URL } from '@/environment'
import { productTypes } from '@/helpers/products/productTypes/types'
import { redirectAuthenticated } from '@/service/loginActions'

/** Fast's editor areas, named after its own products in the plural. */
const FAST_EDITOR_AREA = {
  [productTypes.FAST]: 'fasts',
  [productTypes.ASSESSMENT]: 'exams',
  [productTypes.FAST_SURVEY]: 'surveys',
  [productTypes.DIALOGUE]: 'talks',
}

export const redirectAuthenticatedFAST = async (productType) => {
  const area = FAST_EDITOR_AREA[productType]

  await redirectAuthenticated({
    url: FAST_URL,
    newTab: true,
    redirectPath: area ? `/editor/${area}/new` : undefined,
  })
}
